import BaseService from "./BaseService";

export default class MapEventService extends BaseService {
  constructor() {
    super();
  }

  async buildSelector() {
    if (window.redseats.eventKey) {
      const selector = JSON.parse(sessionStorage.getItem("rs_selector"));
      const body = {
        EventId: window.redseats.eventKey,
        AvailableCategories: window.redseats.availableCategories,
        SeatStatusColor: window.redseats.seatStatusColor,
        SeatStatusIcon: window.redseats.seatStatusIcon,
        Channels: window.redseats.channels ?? []
      };
      const result = await super.callApi(
        "mapevent/build/selector",
        "Post",
        body,
        { selectorToken: selector?.token ?? "" }
      );
      if (result.statusCode == "200") {
        sessionStorage.setItem(
          "rs_selector",
          JSON.stringify({
            key: result.data.selectorKey,
            token: result.data.selectorToken,
          })
        );
        return result.data;
      } else return super.htmlError(result.errorMessage);
    }

    return super.htmlError("Event key does not exist");
  }
  async buildNotForSale() {
    if (window.redseats.eventKey) {
      const body = {
        EventId: window.redseats.eventKey,
        SeatStatusColor: window.redseats.seatStatusColor,
        SeatStatusIcon: window.redseats.seatStatusIcon,
      };
      const result = await super.callApi(
        "mapevent/build/notforsale",
        "Post",
        body
      );
      if (result.statusCode == "200") return result.data;
      else return super.htmlError(result.errorMessage);
    }

    return super.htmlError("Event key does not exist");
  }
  async buildChannel() {
    if (window.redseats.eventKey) {
      const body = {
        EventId: window.redseats.eventKey,
      };
      const result = await super.callApi(
        "mapevent/build/channel",
        "Post",
        body
      );
      if (result.statusCode == "200") return result.data;
      else return super.htmlError(result.errorMessage);
    }

    return super.htmlError("Event key does not exist");
    }
    async buildDetail() {
        if (window.redseats.eventKey) {
            const body = {
                EventId: window.redseats.eventKey,
                SeatStatusColor: window.redseats.seatStatusColor
            };
            const result = await super.callApi(
                "mapevent/build/detail",
                "Post",
                body
            );
            if (result.statusCode == "200") return result.data;
            else return super.htmlError(result.errorMessage);
        }

        return super.htmlError("Event key does not exist");
    }
}
